export default function insertWebchat() {
  const script = document.createElement('script');

  script.src =
    'https://connect.podium.com/widget.js#API_TOKEN=15a13622-4661-4337-93e4-e47f168e4a88';
  script.id = 'podium-widget';
  script.setAttribute('data-api-token', '15a13622-4661-4337-93e4-e47f168e4a88');

  document.head.appendChild(script);
}
